module.exports = __webpack_public_path__ + "static/media/Picture6.6474e851.jpg";